module.exports = __webpack_public_path__ + "d7e280.png";